import urls from '@data/i18n/urls.json'

import type { SubNavItems } from '@lib/types/account-ui'

export function getRouteSubNavItems(routePathname: string) {
	const subNavItemsArray = Object.entries(subNavItems)

	const routeNavItems = subNavItemsArray.find(
		([route]) => route === routePathname || routePathname.startsWith(route)
	)

	if (routeNavItems?.[1])
		return { indexNavPage: routeNavItems?.[0], verticalNavItems: routeNavItems[1] }

	return null
}

export const subNavItems: SubNavItems = {
	'/profile/account': [
		{
			label: urls.accountNav.info.title,
			url: urls.accountNav.info.url,
			filePathName: urls.accountNav.info.filePathName,
			svgCode: 'fa-thin fa-address-card'
		},
		{
			label: urls.accountNav.payment.title,
			url: urls.accountNav.payment.url,
			filePathName: urls.accountNav.payment.filePathName,
			svgCode: 'fa-thin fa-credit-card-front'
		},
		{
			label: urls.accountNav.notifications.title,
			url: urls.accountNav.notifications.url,
			filePathName: urls.accountNav.notifications.filePathName,
			svgCode: 'fa-thin fa-envelope-open'
		}
	],
	'/profile/orders': [
		{
			label: urls.ordersNav.subscriptions.title,
			url: urls.ordersNav.subscriptions.url,
			filePathName: urls.ordersNav.subscriptions.filePathName,
			svgCode: 'fa-thin fa-cube'
		},
		{
			label: urls.ordersNav.shop.title,
			url: urls.ordersNav.shop.url,
			filePathName: urls.ordersNav.shop.filePathName,
			svgCode: 'fa-thin fa-store'
		}
	]
}
